import { EditModal } from "../../shared/components/edit-table/edit-modal";
import { EditTable, EditTableSortColumn } from "../../shared/components/edit-table/edit-table";
import { TableRenderer, TableRenderType } from "../../shared/components/edit-table/table-renderer";
import { CabHubConnection } from "../../shared/entities/cab-hub/connection/cab-hub-connection";
import { JsonItem, PickListItem } from "../../shared/entities/pick-list/pick-list.entities";
import { getDisplayDate, getMonthYearDisplay } from "../../shared/scripts/date-functions";
import { TableColumnGroup } from "../../shared/scripts/table-column-visibility";
import { CabHubCompletedSurveyRow, CabHubConnectionDetailsVm, CabHubConnectionEntity, CabHubScope } from "./scripts/cab-hub-tracking.entities";
import { CabHubConnectionForm } from "./scripts/cab-hub-tracking.forms";
import { CompletedSurveyTable, CompletedSurveyTableType } from "./scripts/cab-hub-tracking.tables";
import { CompletedSurveyViewModal, CompletedSurveyViewType } from "./scripts/completed-survey.view";


export class CabHubConnectionDetailsPage {  
    viewModel: CabHubConnectionDetailsVm;
    completedSurveyTable: CompletedSurveyTable;
    completedSurveyView: CompletedSurveyViewModal;
    tableRenderer: TableRenderer;
    editConnectionModal: EditModal;
    editNotesModal: EditModal;

    constructor(viewModel: CabHubConnectionDetailsVm) {
        this.viewModel = viewModel;
        this.tableRenderer = new TableRenderer(viewModel.PickLists);
        this.completedSurveyTable = new CompletedSurveyTable(CompletedSurveyTableType.Connection);
        this.completedSurveyView = new CompletedSurveyViewModal("survey-view-modal", viewModel.PickLists);

        this.editConnectionModal = new EditModal({
            isAdd: false,
            editModalId: "survey-edit-modal",
            formSections: CabHubConnectionForm.getFormSections(),
            modalTitle: "Edit Connection",
            saveFn: this.saveConnection,
            displayPropertyFn: this.getConnectionDisplay
        });

        this.editNotesModal = new EditModal({
            isAdd: false,
            editModalId: "survey-edit-modal",
            formSections: CabHubConnectionForm.getNotesCheckInFormSections(),
            modalTitle: "Edit Notes & Check-In",
            saveFn: this.saveConnection,
            displayPropertyFn: this.getConnectionDisplay
        })

        
        this.initialize();     
    }

    private initialize(): void {       
        this.initializeCompletedSurveys();
        this.initializeAgreementDownload();
        this.initializeEditBtns();
    }

    private initializeCompletedSurveys(): void {
        let tableTarget = $(`#completed-survey-table-container`);
        let tableHtml = this.completedSurveyTable.generateHtml();
        tableTarget.empty().html(tableHtml);
        this.completedSurveyTable.initialize(this.viewModel.SurveyHistory, this.viewModel.PickLists);

        tableTarget.on("click", ".js-view-completed-survey", (e) => {
            let target = $(e.currentTarget);
            let targetId = <string>target.data("surveyId");
            let targetType = <string>target.data("surveyType")
            let foundSurvey = this.viewModel.SurveyHistory.find(survey => survey.SurveyId.toString() == targetId && survey.SurveyType == targetType);
            if (foundSurvey) {
                let type = CompletedSurveyViewType.CAB;
                if (targetType?.toLowerCase() != "cab") {
                    type = CompletedSurveyViewType.Hub;
                }
                this.completedSurveyView.openModal(foundSurvey, type);
            }
        })
    }

    private initializeEditBtns(): void {
        $("#edit-connection-button").on("click", () => {
            let connection = this.viewModel.Connection;
            this.editConnectionModal.openModal([connection], this.viewModel.PickLists);
        });

        $("#edit-notes-btn").on("click", () => {
            let connection = this.viewModel.Connection;
            this.editNotesModal.openModal([connection], this.viewModel.PickLists);
        })
    }

    private async saveConnection(items: any[], isAdd: boolean): Promise<string> {
        try {
            let saveEndpoint = "/api/cab-match/connection";
            await $.ajax(saveEndpoint, {
                method: "POST",
                data: JSON.stringify(items),
                contentType: "application/json"
            });

            window.location.reload(); // refresh on save;
        }
        catch {
            return "An error has occurred while saving. Please refresh the page and try again."
        }

        return "";
    }

    private getConnectionDisplay(connection: CabHubConnection, pickLists: JsonItem[]): string {
        let returnText = "Connection";
        let hubList: PickListItem[] = pickLists.find(list => list.Id == "pl-short-hub")?.Json;
        let userList: PickListItem[] = pickLists.find(list => list.Id == "pl-user")?.Json;

        let foundHub = hubList.find(hub => hub.Id == connection.HubId);
        let foundUser = userList.find(user => user.Id == connection.CabMemberUserId);

        if (foundHub && foundUser) {
            returnText = `${foundUser.Value} | ${foundHub.Value}`;
        }
        return returnText;
    }

    private async initializeAgreementDownload(): Promise<void> {
        const uploadId = this.viewModel.DocumentUploadId;

        if (!uploadId) {
            return;
        }

        try {
            const result: any = await $.ajax("/api/upload-service/get-files",
                {
                    method: "POST",
                    headers: { "RequestVerificationToken": String($('input[name="__RequestVerificationToken"]').val() ?? "") },
                    contentType:"application/json; charset=utf-8",
                    data: JSON.stringify({
                        rootFolderPath:"cab-hub-uploads",
                        uuidArray: [uploadId]
                    })
                }
            );

            const document = result?.items?.[0];

            if (!document) {
                $("#cab-hub-agreement-loading").text("Agreement document unavailable");
                return;
            }

            const filePath = encodeURI(document.id);

            $("#cab-hub-agreement-download")
                .attr("href", `/api/upload-service/download-file?filePath=${filePath}`)
                .attr("download", document.text)
                .text(document.text || "View agreement document")
                .removeClass("d-none");

            $("#cab-hub-agreement-loading").remove();
        }
        catch (error) {
            console.error("Unable to load agreement document:", error);
            $("#cab-hub-agreement-loading").text("Agreement document unavailable");
        }
    }
}

